import { schemaCommon } from "components/Reusable/Bit/FormikSchema"
import * as yup from "yup"

const groupPurchasesInitialValues = {
  groupName: "",
  amount: undefined,
}

const schemaGroupPurchasesGroupName = yup
  .object({
    name: schemaCommon.groupName,
  })
  .defined()

const schemaGroupPurchasesLeaderDetails = yup
  .object({
    firstName: schemaCommon.firstName,
    lastName: schemaCommon.lastName,
    phoneNumber: schemaCommon.phoneNumber,
    email: schemaCommon.email,
    checkedOne: schemaCommon.checkbox,
  })
  .defined()

const schemaGroupPurchasesRecipient = yup
  .object({
    name: schemaCommon.firstName,
    phoneNumber: schemaCommon.phoneNumber,
    senderBlessing: schemaCommon.senderBlessing,
    // email: schemaCommon.email,
  })
  .defined()

export default {
  groupPurchasesInitialValues,
  schemaGroupPurchasesGroupName,
  schemaGroupPurchasesLeaderDetails,
  schemaGroupPurchasesRecipient,
}
